import { SVGProps } from "react"


export const Vector = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="207"
      height="103"
      viewBox="0 0 207 103"
      fill="none"
      {...props}
    >
      <g opacity="0.2" filter="url(#filter0_f_4249_21780)">
        <path
          d="M103.201 4.0409C103.201 4.0409 104.275 81.6396 114.476 91.8497C124.677 102.06 202.275 103.201 202.275 103.201L4.04088 103.114C4.04088 103.114 81.6396 102.041 91.8497 91.8398C102.06 81.6386 103.201 4.0409 103.201 4.0409Z"
          fill="white"
        />
      </g>
      <defs>
        <filter
          id="filter0_f_4249_21780"
          x="0.000116348"
          y="-5.72205e-06"
          width="206.316"
          height="107.242"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="2.02045"
            result="effect1_foregroundBlur_4249_21780"
          />
        </filter>
      </defs>
    </svg>
  )
}
